import { Accordion } from "flowbite-react"
  const VueJsFAQ: React.FC = () => { return (
        <>
          <Accordion>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">Why should you choose Vue.js development services for your upcoming project?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Here is why Vue.js is the right choice for your next project - <br/>
                    <ul className="list mb-0 mt-4">
                      <li>High performance</li>
                      <li>Great flexibility</li>
                      <li>Secure and fast</li>
                      <li>Two-way data binding</li>
                      <li>Simple & user-friendly</li>
                      <li>Reliable third-party integration</li>
                      <li>Animations and interactive elements</li>
                      <li>Seamless integration with multiple apps</li>
                    </ul>
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> What are the benefits of Vue.js framework?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Vue.js offers a wide range of benefits such as a weightless codebase, easy upgrade, powerful, excellent documentation, faster development, adaptability, and great scalability compared to other technologies.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> Which applications can you develop using Vue.js framework?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Vue.js framework can help you develop a variety of web applications, including- <br/>
                  <ul className="list mb-0 mt-3">
                      <li>Team collaboration applications</li>
                      <li>Real-time applications</li>
                      <li>Streaming applications</li>
                      <li>Simple web applications</li>
                      <li>Large scale applications</li>
                    </ul>
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">Which big brands use Vue.js?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Various huge brands that have created real-time apps using the Vue.js framework for their business are Alibaba, IBM, Apple, Google, BMW, Adobe, Trivago, Behance, Bitpanda, Louis Vuitton, Wizz Air, UpWork, Netflix, Euronews, Nintendo, and others.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">How much will it cost for a Vue.js development project?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  The cost of your project depends on various factors such as the intricacy of your app, the technical expertise of programmers, the experience of developers, features to integrate, total development hours, and more. Please share your exact project requirements so that our team can revert with a project quote.
                  </div>
                </Accordion.Content>
              </Accordion.Panel>
            </Accordion>
        </>
        )
}

export default VueJsFAQ
